// diningMomentDismissal — localStorage-backed per-window dismissal for
// DiningMomentCard. No backend field for this exists (or is warranted) —
// it's purely "don't show me this specific suggestion again."
//
// Identity is `${mealType}:${windowEnd.getTime()}`, not `windowStart` —
// detectDiningMoments computes windowStart as
// `Math.max(interval.startMs, bandStartMs, nowMs)`, which tracks the clock
// and changes every tick. windowEnd only depends on the free interval and
// the fixed meal band, so it's stable across ticks for "the same"
// opportunity, and naturally becomes a new identity once that window closes
// and a genuinely different one is found later.

const STORAGE_KEY_PREFIX = 'travelflow_dining_dismissed_';

function buildKey(tripId) {
  return `${STORAGE_KEY_PREFIX}${tripId}`;
}

function momentIdentity(diningMoment) {
  return `${diningMoment.mealType}:${diningMoment.windowEnd.getTime()}`;
}

/**
 * @param {string} tripId
 * @param {Object|null} diningMoment - `detectDiningMoments(...)` result
 * @returns {boolean}
 */
export function isDiningMomentDismissed(tripId, diningMoment) {
  if (!tripId || !diningMoment) return false;
  try {
    return window.localStorage.getItem(buildKey(tripId)) === momentIdentity(diningMoment);
  } catch (_err) {
    return false;
  }
}

/**
 * @param {string} tripId
 * @param {Object} diningMoment - `detectDiningMoments(...)` result (non-null)
 */
export function dismissDiningMoment(tripId, diningMoment) {
  if (!tripId || !diningMoment) return;
  try {
    window.localStorage.setItem(buildKey(tripId), momentIdentity(diningMoment));
  } catch (_err) {
    // localStorage unavailable (private browsing, quota, SSR) — dismissal
    // simply won't persist across reloads; not worth surfacing an error for.
  }
}
